module.exports = __webpack_public_path__ + "img/xero-empty-state.3b0dadc5.svg";